/** @format */

import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getNewHireEditorDataStart } from '../../redux/new-hire-ref/new-hire-ref.actions';
// import TBButton from '../../components/trueblue-button/trueblue-button.component';
// import FreshdeskButton from '../../components/freshdesk-button/freshdesk-button.component';
import NewHireButton from '../../components/newhire-button/newhire-button.component';
import TerminationButton from '../../components/termination-button/termination-button.component';

// import VoucherStatusUpdate from '../../components/voucher-update/voucher-update.component';
const AutomationPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNewHireEditorDataStart());
  }, [dispatch]);

  return (
    <Container
      sx={{
        display: 'flex',
        width: 'auto',
      }}
    >
      <Grid
        container
        spacing={0}
        sx={{
          '.MuiGrid-item': {
            padding: '8px',
            textAlign: 'center',
          },
        }}
      >
        {/* <Grid item>
          <TBButton />
        </Grid> */}
        {/* <Grid item>
          <FreshdeskButton />
        </Grid> */}
        <Grid item>
          <NewHireButton />
        </Grid>
        <Grid item>
          <TerminationButton />
        </Grid>
      </Grid>
    </Container>
  );
};

export default AutomationPage;
